// extracted by mini-css-extract-plugin
export var entityChip = "_sp-0";
export var entityChipMissing = "_sp-1";